<template>
  <div class="flex items-center rounded-md">
    <BaseInput
      class="w-full leading-tight text-gray-700 rounded-md focus:outline-none max-h-10"
      type="text"
      v-model="input"
      icon="left"
      color="light"
      :placeholder="placeholder">
      <template #icon-left>
        <Icon
          icon="mdi:magnify"
          class="self-center transform scale-x-[-1] h-6 w-6 ml-5 text-slate-300" />
      </template>
    </BaseInput>
  </div>
</template>

<script setup lang="ts">
import BaseInput from '@/components/common/BaseInput.vue';
import { Icon } from '@iconify/vue';

defineProps<{
  placeholder?: string;
}>();

const input = defineModel<string>();
</script>
